import { render } from "./AdButton.vue?vue&type=template&id=15c88d0a&scoped=true"
import script from "./AdButton.vue?vue&type=script&lang=js"
export * from "./AdButton.vue?vue&type=script&lang=js"

import "./AdButton.vue?vue&type=style&index=0&id=15c88d0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15c88d0a"]])

export default __exports__